// modifyFilterNode — VQE-Edit edit-action: replace the predicate text of the
// leaf at a given NodePath in the WHERE tree. Builds an SR-Edit
// `modify-where-node` op and delegates to `commitEdit`.
//
// PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice 3B.3 — path-addressed WHERE edit.

import type { BooleanClauseTarget, NodePath } from '../../../../sql-resolver/types/structuralEdit';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

/**
 * Edit the predicate text of the leaf at `path` in the WHERE (default) or
 * HAVING (`clause: 'having'`) tree.
 */
export async function modifyFilterNode(
  path: NodePath,
  newText: string,
  ctx: CommitEditCtx,
  clause?: BooleanClauseTarget,
): Promise<void> {
  const trimmed = newText.trim();
  if (path.length === 0 || trimmed.length === 0) return;
  await commitEdit({ op: 'modify-where-node', path, newText: trimmed, clause }, ctx);
}
